import { render, staticRenderFns } from "./CourseBundleShow.vue?vue&type=template&id=25d31372&scoped=true&"
import script from "./CourseBundleShow.vue?vue&type=script&lang=js&"
export * from "./CourseBundleShow.vue?vue&type=script&lang=js&"
import style0 from "./CourseBundleShow.vue?vue&type=style&index=0&id=25d31372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d31372",
  null
  
)

export default component.exports